import React from "react";
import CaseStudyPage from "./CaseStudyPage";

const CaseStudyLawFirm = () => (
  <CaseStudyPage
    category="Law"
    client="Commercial Law Firm (anonymized)"
    title="Contract Intelligence That Replaced 200+ Hours of Manual Clause Review Per Month"
    heroImage="https://images.unsplash.com/photo-1565008447742-97f6f38c985c?auto=format&fit=crop&w=1600&q=80"
    challenge="Senior associates were reviewing contracts manually for standard risk clauses — liability caps, indemnification terms, termination rights, IP ownership, governing law — at a rate that didn't scale with the firm's client volume. Junior associates were prone to inconsistency. The firm was leaving revenue on the table by under-billing for review time and over-resourcing routine work."
    whatWeBuilt="A legal document intelligence system built on a fine-tuned model trained on the firm's own contract library and clause taxonomy. The system automatically extracts, classifies, and flags key clauses across any contract format — highlighting deviations from standard positions, surfacing high-risk terms, and generating a structured review summary that reduces associate review time to a final check rather than a full read."
    results={[
      { value: "200+ hrs", label: "Manual clause review automated per month" },
      { value: "94%+", label: "Clause extraction accuracy across contract types" },
      { value: "45 min", label: "Associate review time per contract (down from 3-4 hours)" },
      { value: "40%", label: "Higher contract volume handled without additional headcount" },
      { value: "Significantly improved", label: "Junior associate consistency across reviews" },
    ]}
    takeaway="Legal document intelligence isn't about replacing lawyers. It's about making sure the work that doesn't need a lawyer isn't being done by one. The system paid for itself in the first month."
  />
);

export default CaseStudyLawFirm;
